import * as types from '../constants/actionTypes';

export default function auth(state = {
  isAuthenticated: false,
  id: undefined,
  username: undefined,
  token: undefined,
  expires: undefined,
  roles: []
}, action) {

  switch (action.type) {

    case types.OAUTH__LOGIN: {

      const { id, username, token, expires, roles, redir } = action.payload;
      return Object.assign({}, state, {
        isAuthenticated: true,
        id,
        username,
        token,
        expires,
        roles,
        redir
      });
    }

    case types.OAUTH__TOKEN__REFRESH__SUCCEEDED: {

      const { id, username, token, expires, roles, redir } = action.payload;
      return Object.assign({}, state, {
        isAuthenticated: true,
        id,
        username,
        token,
        expires,
        roles,
        redir
      });
    }

    case types.OAUTH__TOKEN__EXPIRED:{

      return Object.assign({}, state, {
        isAuthenticated: false,
      });

    }

    case types.LOGOUT__COMPLETED: {
      return Object.assign({}, state, {
        isAuthenticated: false,
        id: undefined,
        username: undefined,
        token: undefined,
        expires: undefined,
        roles: undefined
      });
    }

    default: {
      /*
      return Object.assign({}, state, {
      isAuthenticated: true,
          id: 1,
          username: "cmsanche",
          token: "YTJhMDQxYzY5ZWQ4OWNkNTU4MWM0ZDZkYTkyMGNkNzQwNTkzNTAwODZkOTYxNmQ1N2RjMzc0NzllNjA3ZGYxOA",
          expires: 2147483647,
          roles: ["ROLE_USER","ROLE_DROPBOX_USER"]
      });
      */
      return state;
    }
  }


}



/** WEBPACK FOOTER **
 ** ./src/reducers/authReducer.js
 **/